import { SubTitleWithImage } from "@stories/atoms/SubTitle/SubTitle";
import * as RouteHelper from "@utils/routes";
import { PageBreadcrumbs } from "@stories/atoms/PageBreadcrumbs/PageBreadcrumbs";
import { useProjectContext } from "@hooks/context/useProjectContext";
import { Grid } from "@mui/material";
import { MonthSelect } from "@stories/atoms/MonthSelect/MonthSelect";
import { useEffect, useState } from "react";
import { AnalyticsPageTabs } from "@stories/molecules/AnalyticsPageTabs/AnalyticsPageTabs";
import { ContractorAnalyticsLabourSpend } from "@stories/molecules/ContractorAnalyticsLabourSpend/ContractorAnalyticsLabourSpend";
import { useAnalysis } from "@hooks/crud/useAnalysis";
import {
  PackageAnalysisAggregateLineItem,
  getAnalysisPackageAcrossMonth,
} from "@interfaces/analysis";
import { ProjectLoader } from "@stories/atoms/Loaders/ProjectLoader/ProjectLoader";
import { StyledCard } from "@stories/atoms/StyledCard/StyledCard";
import { useProfileContext } from "@hooks/context/useProfileContext";

export const AnalyticsSpend = () => {
  const { userOrganisation } = useProfileContext();
  const { selectedProject, selectedProjectOrganisation } = useProjectContext();
  const today = new Date();
  const [reportDate, setReportDate] = useState(
    today < selectedProject.endDate ? today : selectedProject.endDate
  );
  const { analysis, getAnalysis, isAnalysisLoading } = useAnalysis();
  const [mainAnalysis, setMainAnalysis] =
    useState<PackageAnalysisAggregateLineItem[]>();

  useEffect(() => {
    getAnalysis(selectedProject.id);
  }, []);

  useEffect(() => {
    if (analysis) {
      if (userOrganisation) {
        const aggregationAnalysis = getAnalysisPackageAcrossMonth(
          analysis,
          reportDate.getMonth(),
          reportDate.getFullYear()
        );
        aggregationAnalysis?.sort(
          (
            a: PackageAnalysisAggregateLineItem,
            b: PackageAnalysisAggregateLineItem
          ) => {
            if (a.contractorId !== b.contractorId) {
              return a.contractorId === userOrganisation.id ? -1 : 1;
            }
            return a.contractorName < b.contractorName ? -1 : 1;
          }
        );
        setMainAnalysis(aggregationAnalysis);
      }
    }
  }, [analysis, reportDate]);

  if (!analysis || !mainAnalysis || isAnalysisLoading || !userOrganisation) {
    return <ProjectLoader />;
  }
  const breadcrumbs = [
    {
      path: RouteHelper.analyticsSpend(selectedProject.id),
      name: `${selectedProject.projectName} Analytics / Social Procurement`,
    },
  ];

  return (
    <>
      <PageBreadcrumbs
        title={`${selectedProject.projectName} Social Procurement`}
        organisationLogo={selectedProjectOrganisation.organisationLogo}
        links={breadcrumbs}
      />
      <StyledCard>
        <Grid container spacing={2} sx={{ padding: "24px" }}>
          <Grid item xs={12} md={8}>
            <AnalyticsPageTabs />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              display: "flex",
              alignContent: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            <MonthSelect
              setDate={setReportDate}
              date={reportDate}
              minDate={selectedProject.startDate}
              maxDate={selectedProject.endDate}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <ContractorAnalyticsLabourSpend analysis={mainAnalysis} />
          </Grid>
        </Grid>
      </StyledCard>
    </>
  );
};
